export default __webpack_public_path__ + "static/media/ps.ab148806.png";